<template>
  <zj-layout-container>
    <zj-layout-main>
      <el-form
        :model="viewData"
        :rules="rules"
        ref="event-plan-submit"
        class="zj-search-form"
        :disabled="true"
      >
        <el-form-item label="事件名称：" style="display: inline-block">
          <el-input
            v-model="viewData.EventName"
            style="width: 23rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件编号：" style="display: inline-block">
          <el-input v-model="viewData.EventNo" style="width: 23rem"></el-input>
        </el-form-item>
        <el-form-item label="事件级别：" style="display: inline-block">
          <el-select v-model="viewData.ConfirmEventLevel" style="width: 23rem">
            <el-option
              v-for="item in EventLevelOptions"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事件类型：" style="display: inline-block">
          <el-select v-model="viewData.ConfirmEventType" style="width: 23rem">
            <el-option
              v-for="item in EventTypeOptions"
              :key="item.ItemKey"
              :label="item.Extend1"
              :value="item.ItemKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事发地点：" style="display: inline-block">
          <el-input
            v-model="viewData.EventLocation"
            style="width: 57rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事发时间：" style="display: inline-block">
          <el-date-picker
            style="width: 23rem"
            type="datetime"
            placeholder="选择日期"
            v-model="viewData.EventDate"
            :disabled="EventInfoEdit"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上报人姓名：" style="display: inline-block">
          <el-input
            v-model="viewData.ReporterName"
            style="width: 21.5rem"
          ></el-input>
        </el-form-item>
        <el-form-item label="事件描述：" style="display: inline-block">
          <el-input
            type="textarea"
            v-model="viewData.EventContent"
            style="width: 57rem"
          ></el-input>
        </el-form-item>
        <div style="width: 100%; height: 0; border-top: 1px solid #eee"></div>
      </el-form>
      <el-form :model="viewData" class="zj-search-form">
        <el-form-item
          label="选择预案："
          style="display: inline-block; margin-top: 2rem"
        >
          <el-select
            style="width: 57rem"
            v-model="viewData.Plan"
            @visible-change="selectPlan"
          >
            <el-option
              v-for="item in EventPlanOptions"
              :key="item.PlanId"
              :label="item.PlanName"
              :value="[item.PlanId, item.PlanName]"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer style="text-align: center">
      <el-button @click="onBack()">取消</el-button>
      <el-button @click="submitForm('event-plan-submit')">启动预案</el-button>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
export default {
  data() {
    return {
      EventTypeOptions: [],
      EventLevelOptions: [],
      EventPlanOptions: [],
      rules: {
        PlanId: [{ required: true, message: "请选择预案" }],
      },
      toUrl: "/plugin/Emergency/UI/EmergencyOperations",
      msgKey: "MessageKey_EmergencyPlanExecute",
    };
  },
  props: {
    viewData: Object,
  },
  watch: {
    viewData() {
      this.GetPlanData();
    },
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    //取消按钮
    onBack() {
      this.$emit("cancel", {});
    },
    //确定按钮
    submitForm() {
      if (!this.viewData.Plan) {
        this.errmsg("请选择预案");
        return false;
      }

      let that = this;

      this.viewData.Status = 4;
      new MyApis.EmergencyEventApi()
        .UpdateItem(this.viewData)
        .then((r) => {
          r = r.data.Data;
          console.log(r);

          //todo启动应急
          if (r) {
            let executId = ZJApp.ZJUtils.uuid();
            let deptId =
              ZJApp.ZJUser.current.Departments.length > 0
                ? ZJApp.ZJUser.current.Departments[0].OrgId
                : "error-no-department";

            let data = {
              OrgId: deptId,
              ExecutId: executId,
              EventId: that.viewData.EventId,
              EventNo: that.viewData.EventNo,
              EventName: that.viewData.EventName,
              PlanId: that.viewData.Plan[0],
              PlanName: that.viewData.Plan[1],
              Status: 1,
              Creater: ZJApp.ZJUser.current.UserName,
              Modifier: ZJApp.ZJUser.current.UserName,
            };
            new MyApis.ExecutRecordApi()
              .StartPlan(data)
              .then((record) => {
                var msgcontent = {
                  key: this.msgKey,
                  data: executId,
                };
                this.$notify.broadcase(msgcontent);

                record = record.data.Data;
                this.logInfo.ActionName = "启动应急事件";
                this.logInfo.LogMessage = record
                  ? "应急事件启动成功"
                  : "应急事件启动失败";
                this.logInfo.ModuleName = "应急系统";
                this.logInfo.PageName = "应急事件信息";
                this.addOperationLog();
                if (record) {
                  this.$router.push({
                    path: this.toUrl,
                    query: {
                      ExecutId: executId,
                    },
                  });
                }
              })
              .catch((e) => {
                console.log(e);
                this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
              });

            // this.$emit("search", {});
            // this.$emit("ok", {});
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    GetPlanData() {
      new MyApis.PlanApi()
        .FindByConditions({
          PlanState: "EmergencyPlanStatus-QY",
          FitEventType: this.viewData.ConfirmEventType,
          Validity: 1,
        })
        .then((r) => {
          var data = r.data.Data;
          this.EventPlanOptions = data;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    selectPlan(val) {
      if (val && this.EventPlanOptions.length === 0) {
        this.errmsg("该事件类型暂无可供选择预案，请先在预案管理中添加预案");
      }
    },
  },
  created: function () {
    this.config
      .getUValue("EmergencyService:FitEventType", "")
      .then((eventtypeconf) => {
        this.EventTypeOptions = eventtypeconf.JValue;
      })
      .catch((e) => {
        console.log(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      });

    this.config
      .getUValue("EmergencyService:EmergencyEventLevel", "")
      .then((eventlevelconf) => {
        this.EventLevelOptions = eventlevelconf.JValue;
      })
      .catch((e) => {
        console.log(e);
        this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      });
    this.GetPlanData();
  },
};
</script>
